import type { Exercise } from '../types/content';
import type { AttemptInput, ProgressSummary, VerbPhraseCourse, VocabularyDetail, VocabularyLibraryPage } from '../types/api';
import { apiRequest } from './client';

export const learningApi = {
  vocabularyTraining: (limit = 10) => apiRequest<{
    strategy: string;
    availableExercises: number;
    contextualWords: number;
    dueCount: number;
    newCount: number;
    exercises: Exercise[];
  }>(`/api/training/vocabulary?limit=${limit}`),
  vocabularyPractice: (itemId: string) => apiRequest<{ exercise: Exercise; exercises: Exercise[] }>(
    `/api/training/vocabulary/${encodeURIComponent(itemId)}`
  ),
  vocabularyLibrary: (offset: number, limit: number, query: string, status: string) => {
    const parameters = new URLSearchParams({ offset: String(offset), limit: String(limit), status });
    if (query.trim()) parameters.set('q', query.trim());
    return apiRequest<VocabularyLibraryPage>(`/api/library/vocabulary?${parameters}`);
  },
  vocabularyDetail: (itemId: string) => apiRequest<VocabularyDetail>(
    `/api/library/vocabulary/${encodeURIComponent(itemId)}`
  ),
  verbPhraseCourse: () => apiRequest<VerbPhraseCourse>('/api/verb-phrases'),
  verbPhraseTraining: (moduleId: string, limit = 10) => apiRequest<{ moduleId: string; exercises: Exercise[] }>(
    `/api/verb-phrases/training?module=${encodeURIComponent(moduleId)}&limit=${limit}`
  ),
  progress: (localDate: string) => apiRequest<ProgressSummary>(
    `/api/progress/summary?date=${encodeURIComponent(localDate)}`
  ),
  saveAttempt: (attempt: AttemptInput) => apiRequest<{ attemptId: string }>('/api/attempts', {
    method: 'POST',
    body: JSON.stringify(attempt)
  })
};
